<template>
  <!-- 标题文本组件库 -->
  <div
    style="position: relative"
    class="captiontext"
    :style="{ background: datas.backColor }"
    @click="handleClick"
  >
    <div v-if="!isShow" :class="{ mask: !isShow }">已隐藏</div>
    <!-- 组件库左侧名称 -->
    <slot name="name" />

    <div
      style="padding: 6px 0"
      :style="{
        'border-bottom': datas.borderBott
          ? '1px solid #F9F9F9'
          : '1px solid #fff',
      }"
    >
      <!-- 标题 -->
      <h2
        :style="{
          fontFamily: datas.fontFamily,
          'font-size': datas.wordSize + 'px',
          'font-weight': datas.wordWeight,
          color: datas.wordColor,
          'text-align': datas.positions,
          height: datas.wordHeight + 'px',
          'line-height': datas.wordHeight + 'px',
          'padding-right': !(datas.positions !== 'center' && datas.more.show)
            ? '0'
            : '60px',
        }"
        v-if="datas.name"
      >
        {{ datas.name }}
      </h2>

      <!-- 描述文字 -->
      <p
        :style="{
          'font-size': datas.descriptionSize + 'px',
          'font-weight': datas.descriptionWeight,
          color: datas.descriptionColor,
          'text-align': datas.positions,
        }"
        style="margin-top: 8px"
        v-if="datas.description"
      >
        {{ datas.description }}
      </p>

      <!-- 更多 -->
      <p
        style="border: 4px solid pink"
        class="more"
        v-show="datas.more.show"
        :class="datas.positions !== 'center' ? 'lef' : ''"
        :style="{
          color: datas.more.type === 0 ? '#38f' : '',
          top: (datas.wordHeight - 6) / 2 + 'px',
        }"
        @click.stop="jumpLink(datas)"
      >
        {{ datas.more.type === 2 ? "" : datas.more.text }}
        <span> {{ datas.more.type === 0 ? "" : ">" }}</span>
      </p>
    </div>

    <!-- 删除组件 -->
    <slot name="deles" />
  </div>
</template>

<script>
export default {
  name: "captiontext",
  props: {
    datas: Object,
    isShow: Boolean,
  },
  methods: {
    // 点击事件
    handleClick() {
      console.log('点击了标题文本组件库leleleleleleeleleelleleleel', this.datas)
       this.$emit(
        "handleCallbackComponent",
        {
          customStyle: {},
          handler: "handleClickComponent",
          icon: "",
          id: this.datas.parentComponent,
          outline: true,
          ref: `${this.datas.parentComponent}style`,
          text: this.datas.text,
          type: "childrenComponent",
        },
        this.datas,
      );
    },
    // 查看更多点击事件
    jumpLink() {
      if (!this.$store.state.modules.templateData.tabBar.id)
        return this.$message.error("请先添加底部导航栏");
      if (
        !this.datas.more.http.internalLink &&
        !this.datas.more.http.externalLink
      )
        return this.$message.error("请选择跳转链接");
      if (this.datas.linkType == 10) {
        // 内部跳转
        this.$router.push({
          path: "/productOpenwecartAfter/admin/Edit",
          query: {
            pageId: this.datas.more.http.internalLink,
          },
        });
      } else {
        //外部跳转
        let url = this.datas.more.http.externalLink.trim();
        if (!/^https?:\/\//.test(url)) url = "https://" + url;
        window.open(url, "_blank"); // 外部链接新窗口打开
      }
    },
  },
};
</script>

<style scoped lang="scss">
.captiontext {
  border: 2px solid #fff;
  box-sizing: border-box;
  width: 100%;
  padding: 0 14px;
  min-height: 20px;
  position: relative;
  h2,
  p {
    word-wrap: break-word;
    min-height: 10px;
  }

  /* 更多 */
  .more {
    font-size: 10px;
    color: #969799;
    text-align: center;
    &.lef {
      position: absolute;
      right: 15px;
      top: 12px;
    }
  }
}
</style>
